import $ from 'cash-dom';
import prequalifySpinner from './prequalify-spinner';
import FirstQuestionHandler from './handlers/FirstQuestionHandler';
import NextQuestionsHandler from './handlers/NextQuestionsHandler';
import PrequalState from './PrequalState';

// NOTE: we need to run this code as soon as possible

prequalifySpinner.show();

$(function () {
	const params = new URLSearchParams(location.search);

	if (params.get('hpq')) {
		prequalifySpinner.hide();
		PrequalState.getInstance().noPrequal = true;
		return;
	}

	const $prequalifyModal = $('#prequalify-modal');

	if ($prequalifyModal.length) {
		PrequalState.getInstance().noPrequal = false;
		PrequalState.getInstance().isPrequalShown = FirstQuestionHandler.handle($prequalifyModal);
	} else {
		PrequalState.getInstance().isPrequalShown = NextQuestionsHandler.handle();
		PrequalState.getInstance().noPrequal = !PrequalState.getInstance().isPrequalShown;
	}
});
